import { render } from "./submit-button.vue?vue&type=template&id=0eba9c3a&ts=true"
import script from "./submit-button.ts?vue&type=script&lang=ts&external"
export * from "./submit-button.ts?vue&type=script&lang=ts&external"

import "./submit-button.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__